var map = {
	"./Sezione Scritti e Discorsi ipotesi B.jpeg": "62ee",
	"./diario.jpg": "04fe",
	"./intervista_scalfari.jpg": "eedd",
	"./memoriale.jpg": "563f",
	"./s1.jpeg": "7b59",
	"./s1v1.jpeg": "afbf",
	"./s1v2.jpeg": "16db",
	"./s1v2t1.jpeg": "d9b6",
	"./s1v2t2.jpeg": "c7b2",
	"./s1v3.jpeg": "e664",
	"./s1v3t1.jpg": "5210",
	"./s1v3t2.jpg": "daff",
	"./s1v4.jpg": "b280",
	"./s1v4t1.jpeg": "5aec",
	"./s1v4t2.jpeg": "e0f5",
	"./s2.jpeg": "235e",
	"./s2v1.jpg": "05b8",
	"./s2v2.jpeg": "8333",
	"./s2v3.jpeg": "4c6c",
	"./s2v4.jpeg": "4814"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc63";